<!--
 * @Author: ivan.ji
 * @Date: 2020-03-09 16:05:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-21 15:16:53
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="announcement-pack card">
        <div class="title">{{$t('公告')}}
            <a class="more"
               @click="$router.push('/mgt/msgs?tab='+'announcement')">
                <i class="icon-arrow-under-o"></i>
            </a>
        </div>
        <ul class="announcement-con"
            v-if="announcements.length">
            <li v-for="(item, k) in announcements"
                :key="k"
                @click="detailFun(item)">
                <span class="tit"
                      style="cursor: pointer;">{{item.noticeTitle}}</span>
                <span class="time">{{item.publishDate}}</span>
            </li>
        </ul>
        <div v-else
             class="no-data">
            <noData></noData>
        </div>
    </div>
</template>
<script>
import noData from '@c/basic/nodata'
import API from '@/service/api'
export default {
    name: 'announcement',
    components: {
        noData
    },
    data () {
        return {
            announcements: []
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        init () {
            this.axios.get(this.urlFormat(API.GET_NOTICE_INFOS, false), {
                params: {
                    pagenum: 0,
                    pagesize: 10
                }
            }).then(res => {
                this.announcements = res
            })
        },
        detailFun (item) {
            this.$router.push({
                path: `/mgt/msgs/${item.noticeId}`,
                query: {
                    id: item.noticeId
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.announcement-pack {
    border-top: 10px solid #f5f6f7;
    .title {
        display: flex;
        justify-content: space-between;
        .more {
            min-width: 50px;
            text-align: right;
            .icon-arrow-under-o {
                display: inline-block;
                transform: rotate(-90deg);
                color: #999999;
                font-size: 10px;
                font-weight: 600;
            }
        }
    }
    .announcement-con {
        font-size: 12px;
        padding: 5px 10px 12px 10px;
        li {
            padding: 5px 5px;
            display: flex;
            justify-content: space-between;
            .tit {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .time {
                color: #999999;
                white-space: nowrap;
                margin-left: 10px;
            }
            &:hover {
                background-color: #f5f6f7;
            }
        }
    }
    .no-data {
        height: calc(~'100% - 40px');
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
